<script setup lang="ts">
import type { captureException, withScope } from "@sentry/vue";
import { inject, onMounted } from "vue";
const sentry = inject<
  { captureException: typeof captureException; withScope: typeof withScope } | undefined
>("SENTRY", undefined);
const props = withDefaults(
  defineProps<{
    error: Error;

    errorCode: string;
  }>(),
  {
    errorCode: `${new Date().getUTCFullYear()}${
      new Date().getUTCMonth() + 1
    }${new Date().getUTCDate()}.${Math.random().toString(36)}`,
  },
);

// eslint-disable-next-line no-undef
const additional = IS_APP && import.meta.env.NODE_ENV === "development" ? props.error : undefined;

onMounted(() => {
  sentry?.withScope((scope) => {
    scope.setExtra("errorCode", props.errorCode);
    scope.setTag("medicusCode", props.errorCode);
    sentry.captureException(props.error);
  });
});
</script>
<template>
  <div class="error-component">
    <div class="title">Something Went Wrong</div>
    <p>{{ errorCode }}</p>
    <p v-if="additional" class="error-text">
      {{ additional }}
    </p>
    <p v-if="additional?.stack" class="error-text">{{ additional.stack }}</p>
  </div>
</template>
<style lang="scss" scoped>
.error-component {
  display: flex;
  flex-direction: column;
  height: 100%;

  align-items: center;
  justify-content: center;

  gap: 0.5rem;

  color: var(--grey-darkest);
  font-size: 16px;

  overflow: auto;

  .title {
    margin-bottom: 10px;
    font-size: 26px;
    line-height: 36px;
  }
}
</style>
